// src/lib/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://ybxvdpxyxbfqioanfrbp.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlieHZkcHh5eGJmcWlvYW5mcmJwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MTgyMDYzNjgsImV4cCI6MjAzMzc4MjM2OH0.D4R33WMCFz2BcQa-MdKd12jKmfLdOjXZ_9DUCgPYEhA';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
